export const selectGreenlightSurveysLoaded = ({ greenlightState }) => {
  return greenlightState.greenlightSurveysLoaded
}
export const selectGreenlightSurveys = ({ greenlightState }) => {
  return greenlightState.greenlightSurveys
}
